"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.WixStyleReactContext = void 0;
var _react = _interopRequireDefault(require("react"));
var WixStyleReactContext = exports.WixStyleReactContext = /*#__PURE__*/_react.default.createContext({
  newColorsBranding: false,
  newBrandingClass: 'no-brand'
});
//# sourceMappingURL=context.js.map